import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leilao03',
  templateUrl: './leilao03.component.html',
  styleUrls: ['./leilao03.component.scss']
})
export class Leilao03Component implements OnInit  {
 
  constructor(private route: ActivatedRoute, private router: Router) {}
 
  ngOnInit(){
  }

  voltar(){
    this.router.navigate([''], { relativeTo: this.route });
  }
}

